import api from './api';

/**
 * Debug API endpoints
 * Only available when DEBUG_MODE is enabled
 */

/**
 * Reset game to deployment phase
 * @param {string} gameId - The game ID to reset
 * @returns {Promise<object>} Response data
 */
export const resetToDeployApi = async (gameId) => {
  const response = await api.post(`/api/games/${gameId}/debug/reset-deploy`);
  return response.data;
};

/**
 * Randomize enemy unit positions during deployment
 * @param {string} gameId - The game ID
 * @returns {Promise<object>} Response data
 */
export const randomizeEnemyPositionsApi = async (gameId) => {
  const response = await api.post(`/api/games/${gameId}/debug/randomize-enemies`);
  return response.data;
};

/**
 * Kill a specific unit instantly (debug only)
 * @param {string} gameId - The game ID
 * @param {number} unitId - The unit ID to kill
 * @returns {Promise<object>} Response data
 */
export const killUnitApi = async (gameId, unitId) => {
  const response = await api.post(`/api/games/${gameId}/debug/kill-unit/${unitId}`);
  return response.data;
};

export default {
  resetToDeployApi,
  randomizeEnemyPositionsApi,
  killUnitApi
};